import React, { useContext } from "react";
import "../landing/Landing.css";
import { Context } from "../../context/Context";
import { Solutions } from "../../components/landing/Solutions/Solutions";
import { WhatsAppFloat } from "../../components/landing/WhatsAppFloat/WhatsAppFloat";

export const SolutionsPage = () => {
  const { lang } = useContext(Context);

  return (
    <div className={`landing-page ${lang === "ar" ? "ar" : "en"}`}>
      <Solutions />
      <WhatsAppFloat />
    </div>
  );
};

export default SolutionsPage;
